export const INTERNAL_MESSAGES = {
	ERROR_MESSAGE:
		'Por el momento los servicios no se encuentran disponibles. Intenta más tarde',
	NO_FOUND_ROWS_TABLE_CUSTOM: 'No hay datos que mostrar',
};
